module.exports = __webpack_public_path__ + "static/img/jd.6142e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jd.png
// module id = BnSa
// module chunks = 1